import HotelBadges from './HotelBadges.component';
export default HotelBadges;